import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { FilterMenuItem } from 'components'
import { CheckboxGroup } from 'lp-components'
import { size, startCase } from 'lodash'
import { formatOptions } from 'utils'

const propTypes = {
  filterOptions: PropTypes.object.isRequired,
}

const defaultProps = {}

function ArtistSearchFilterFields({ filterOptions, ...filterMenuProps }) {
  return (
    <React.Fragment>
      {filterOptions.openToEmployment && (
        <FilterMenuItem
          name="openToEmployment"
          displayName="Open to Employment?"
          isBooleanFilter
          {...filterMenuProps}
        >
          <Field
            name="openToEmployment"
            component={CheckboxGroup}
            label="Open to Employment?"
            labelComponent={CheckboxGroupLegend}
            options={formatOptions(filterOptions.openToEmployment)}
          />
        </FilterMenuItem>
      )}
      {size(filterOptions.levelOfExperience) > 1 && (
        <FilterMenuItem name="levelOfExperience" {...filterMenuProps}>
          <Field
            name="levelOfExperience"
            component={CheckboxGroup}
            labelComponent={CheckboxGroupLegend}
            options={formatOptions(filterOptions.levelOfExperience)}
          />
        </FilterMenuItem>
      )}
      {size(filterOptions.programTypes) > 1 && (
        <FilterMenuItem
          name="taProgramTypes"
          displayName="Teaching Artist Program Types"
          {...filterMenuProps}
        >
          <Field
            name="taProgramTypes"
            options={formatOptions(filterOptions.programTypes)}
            component={CheckboxGroup}
            labelComponent={CheckboxGroupLegend}
          />
        </FilterMenuItem>
      )}
    </React.Fragment>
  )
}

function CheckboxGroupLegend({ label, name }) {
  return <legend className="visually-hidden">{label || startCase(name)}</legend>
}

ArtistSearchFilterFields.propTypes = propTypes
ArtistSearchFilterFields.defaultProps = defaultProps

export default ArtistSearchFilterFields
